import { createSlice } from '@reduxjs/toolkit';
import { IInitialReportedListState } from './types';

const SLICE_NAME = 'ISSUES_SLICE';

export const initialState: IInitialReportedListState = {
  loading: false,
  error: '',
  data: { items: [], nextToken: null },
  issuesDashboard: null,
  searchLoading: false,
};

const userSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchIssuesError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchIssues: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchIssuesSearch: (state, { payload }) => {
      state.searchLoading = true;
      state.error = '';
    },
    fetchIssuesSearchSuccess: (state, { payload }) => {
      state.searchLoading = false;
      state.data = payload;
    },
    fetchIssuesSearchError: (state) => {
      state.searchLoading = false;
      state.error = 'error';
    },
    fetchUserReportedIssuesSearch: (state, { payload }) => {
      state.searchLoading = true;
      state.error = '';
    },
    fetchUserReportedIssuesSearchSuccess: (state, { payload }) => {
      state.searchLoading = false;
      state.data = payload;
    },
    fetchUserReportedIssuesSearchError: (state) => {
      state.searchLoading = false;
      state.error = 'error';
    },
    fetchIssuesSuccess: (state, { payload }) => {
      state.loading = false;
      state.searchLoading = false;
      state.data = payload;
    },
    putIssueStatus: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    putIssueStatusSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
    fetchIssuesDashboardError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchIssuesDashboard: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchIssuesDashboardSuccess: (state, { payload }) => {
      state.loading = false;
      state.issuesDashboard = payload;
    },
    setDefaultIntialIssues: () => {
      return initialState;
    },
  },
});

export default userSlice;
